import serviceImage1 from '../assets/images/services/service-1.jpg';
import serviceImage2 from '../assets/images/services/service-2.jpg';
import serviceImage3 from '../assets/images/services/service-3.jpg';
import serviceImage4 from '../assets/images/services/service-4.jpg';
import serviceImage5 from '../assets/images/services/service-5.jpg';

import icon1 from '../assets/images/icons/category/icon-1.svg';
import icon2 from '../assets/images/icons/category/icon-2.svg';
import icon3 from '../assets/images/icons/category/icon-3.svg';
import icon4 from '../assets/images/icons/category/icon-4.svg';
import icon5 from '../assets/images/icons/category/icon-5.svg';

const SERVICES = [
	{
		img: serviceImage1,
		title: 'projects-plannings',
		icon: icon1,
	},
	{
		img: serviceImage2,
		title: 'virtual-design-build',
		icon: icon2,
	},
	{
		img: serviceImage3,
		title: 'building-engineering',
		icon: icon3,
	},
	{
		img: serviceImage4,
		title: 'building-construction',
		icon: icon4,
	},
	{
		img: serviceImage5,
		title: 'interior-developments',
		icon: icon5,
	},
];

export { SERVICES };
